module.exports = __webpack_public_path__ + "static/media/promo-anetwork-web.92e02bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-anetwork-web.jpg
// module id = 309
// module chunks = 0